import PropTypes from 'prop-types';

import { Flex, LockIcon, Paragraph, THEME_CONSTANTS, useBrand } from '@cof/plastic-components';
import { styled } from 'styled-components';

import partners from '../../../partners';
import { withText } from '../../../text/textStore';

const { COLORS } = THEME_CONSTANTS;

export const NoImpactGuarantee = styled(Paragraph).attrs(() => ({
    fontWeight: 'semiBold',
    size: 'large',
    ml: 'xs',
    p: 0
}))`
    ${({ theme }: any) => theme.components.NoImpactGuarantee}
`;
NoImpactGuarantee.displayName = 'NoImpactGuarantee';

const iconColorMap = {
    [partners.DEFAULT]: COLORS.capitalOne.pink250,
    [partners.VERY]: COLORS.very.pink500,
    [partners.LITTLEWOODS]: COLORS.littlewoods.purple550,
    [partners.LUMA]: COLORS.luma.purple500,
    [partners.ASOS]: COLORS.ASOS.purple350
};
const iconProps = (brand: any) => ({
    size: '2.9rem',
    color: iconColorMap[brand]
});

const QuickcheckGuarantee = ({ Text }: any) => {
    const brand = useBrand();
    return (
        <Flex
            mt={brand === partners.ASOS ? 'md' : 'xs'}
            justifyContent="center"
            alignItems="center"
            data-qa-id="quickcheck-guarantee"
        >
            {/* @ts-expect-error TS2322: Type ' size: string; color: string; "data-qa-id": string; ' is not assignable to type 'IconProps'. */}
            <LockIcon data-qa-id="secure-icon" {...iconProps(brand)} />
            <NoImpactGuarantee data-qm-allow>
                <Text path="NoImpact" />
            </NoImpactGuarantee>
        </Flex>
    );
};

QuickcheckGuarantee.propTypes = {
    Text: PropTypes.func.isRequired
};

const WrappedQuickcheckGuarantee = withText('QuickcheckGuarantee')(QuickcheckGuarantee);
WrappedQuickcheckGuarantee.displayName = 'QuickcheckGuarantee';

export default WrappedQuickcheckGuarantee;
